import { Component, Input, OnInit } from '@angular/core';
import { IBakeryCountry } from '@cakeiteasy/web-utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'delivery-price-check-modal',
  templateUrl: './delivery-price-check-modal.component.html',
  styleUrls: ['./delivery-price-check-modal.component.scss']
})
export class DeliveryPriceCheckModalComponent implements OnInit {
  @Input() bakeryId: number;
  @Input() country: IBakeryCountry;

  constructor(public modal: NgbActiveModal) {
  }

  ngOnInit() {
  }

}
